import { SYS_COLOR_CANVAS_200_DARK } from '@oneaudi/unified-web-alpha-common';
import {
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK,
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
} from '@oneaudi/unified-web-common';

export interface CustomTheme {
  name: 'light' | 'dark';
  colors: Record<string, string>;
}

const colorsDark = {
  colorCanvasDefault: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_DARK,
  colorCanvas200: SYS_COLOR_CANVAS_200_DARK,
};

const colorsLight = {
  colorCanvasDefault: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  colors: colorsDark,
};

export const lightTheme: CustomTheme = {
  name: 'light',
  colors: colorsLight,
};
